<template>
    <div>
        <!--头部-->
        <div class="mrb20">
            <el-button class="mrl20" type="primary"  :class="baseerp+'btn'" @click="addData" :disabled="disabled" size="mini">新增</el-button>
        </div>
        <!--列表-->
        <el-table
                size="mini"
                ref="deliverlight"
                class="mrt20"
                :data="tableData"
                style="width: 100%"
                :height="tableHeight"
                :highlight-current-row="highlightCurrentRow"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                >
            <el-table-column
                    prop="i_id"
                    label="ID号"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_finished_goods')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    label="生产批次号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    :label="$t('form_metering')">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    :label="$t('form_delivery_quantity')">
            </el-table-column>
            <el-table-column
                    prop="vc_state"
                    label="状态">
            </el-table-column>
            <el-table-column
                    prop="vc_state_mq"
                    label="状态">
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    label="交付时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_jfuname"
                    label="交付人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    :label="$t('form_operate')"
                    >
                <template slot-scope="scope">
                    <el-button @click="paymentWatchClick(scope.row)" type="text" size="small" >{{$t('button_edit')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="CurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--交付dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="paymentdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelRenderDialog"
                    v-if="paymentdialogVisible">
                <render-form :render="render" @close="cancelRenderDialog" @getOutputList="getOutputList" ></render-form>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import RenderForm from "./RenderForm";
    export default {
        name: "DeliverList",
        components: {RenderForm},
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                disabled:false,
                render:{},
                highlightCurrentRow:true,
                title:"",
                taskDa:"",
                taskId:"",
                paymentdialogVisible:false,
                vcNo:'',
                begin_time:"",
                end_time:"",
                tableData:[],
                baseerp:"",
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                mid:0,
                tableHeight:0,
            }
        },

        watch:{
            formvalue:{
                handler(){
                    // console.log(this.formvalue,"从tasklist窜过来");
                    if (this.formvalue){
                        this.mid=this.formvalue.i_mid;
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.taskDa = this.formvalue.value;
                                this.taskId = this.formvalue.i_id;
                                this.getOutputList();
                                //console.log(this.taskDa,this.taskId,"this.task");
                                if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                   // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },



        },

        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods: {
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 280;
            },

            //点击添加
            addData(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.paymentdialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.$nextTick(function() {
                        this.$refs.deliverlight.setCurrentRow(this.tableData[0])
                    });
                    this.title="新增";
                    this.highlightCurrentRow=true;
                    this.render={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        value:"",
                        i_id:0,
                        page_size:1,
                        title:"新增",
                        i_mid:this.mid,
                    };
                    // console.log(this.render,"render");
                    this.paymentdialogVisible=true;
                }
            },


            //调用交付列表接口
            async getOutputList(val){
                if(val!=undefined) {
                    this.id=val.wtgsid;
                    this.currentPage=val.pageSize;
                }
                let param = {
                    i_mid: this.mid,
                    i_rwid:this.formvalue.i_id,
                    page_size:this.currentPage,
                    page_count:13,
                };
                let res = await API.getOutputList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    // this.$nextTick(function() {
                    //     this.$refs.deliverlight.setCurrentRow(this.tableData[val.row])
                    // });
                    //console.log(this.tableData,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //关闭交付表
            cancelRenderDialog(){
                this.paymentdialogVisible=false
            },


            //点击编辑
            paymentWatchClick(row){
                this.highlightCurrentRow=true;
                this.title="编辑";
                this.render={
                    taskId:this.taskId,
                    taskDa:this.taskDa,
                    page_size:this.currentPage,
                    title:"编辑",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                // console.log(this.render,"编辑render");
                this.paymentdialogVisible=true;
            },


            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getOutputList();

            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 8px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }


    }

</style>